var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlBeachViewFilled = function SvgHtlBeachViewFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.557 13.732 11.645 12H8.21l-.453 1.633a.5.5 0 1 1-.963-.268l.379-1.366H4.755l-.912 1.732a.5.5 0 0 1-.885-.466l.826-1.57-1.878-1.878a.5.5 0 0 1 .707-.707l1.888 1.888h2.947L8.494 7.23l-1.627-.436H6.86L4.753 6.23a.5.5 0 0 1-.354-.612 4.885 4.885 0 0 1 4.346-3.6 4.9 4.9 0 0 1 2.938.719 4.92 4.92 0 0 1 1.952 2.32c.4.981.466 2.067.188 3.089a.5.5 0 0 1-.612.354l-3.751-1-.974 3.509h3.413a.5.5 0 0 1 .4.2c.06.045.109.102.143.168l1 1.9a.5.5 0 0 1-.443.733.5.5 0 0 1-.442-.278Z"
  })));
};
export default SvgHtlBeachViewFilled;